<google-map height="400px" width="100%" [center]="center" [zoom]="12" [options]="mapOptions">
  <map-marker *ngIf="markerPosition" [position]="markerPosition" [options]="markerOptions">
  </map-marker>
</google-map>
